import RenderComponent from '@/modules/DynamicRenderPage';
import { useTheme } from '@material-ui/core/styles';
import { chartTypes } from 'globalconfig/constants/keys';
import { getQueryStringKeys, loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import React, { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { basicRequest, sortColumnMapping } from './config';
import ParentStyled from './style';

let Styled = loadStyle(ParentStyled, 'pages/web/QuickStats');
const config = loadPageConfig();
const Title = lazy(() => import(`globalcomponents/Title`));
const Content = lazy(() => import(`@/${config.scorecardReport[1].name}`));

const ScorecardReport = (parentProps) => {
  const { fetchReportList, fetchReportChart, vehicles, fetchVehicles } =
    parentProps;
  const [pagination, setPagination] = useState(false);
  const history = useHistory();
  const [request, setRequest] = useState({
    ...basicRequest
  });
  const theme = useTheme();
  const i18n = useTranslation();
  const commonParentProps = { history, i18n, Styled, theme };

  const changeRequest = (fields) => {
    if (fields?.sortCol) {
      const type = fields.sortCol;
      fields.sortCol = sortColumnMapping[type]
        ? sortColumnMapping[type]
        : fields.sortCol;
    }
    setRequest({ ...basicRequest, ...request, ...fields });
  };

  useEffect(() => {
    !vehicles.vehicleList.length &&
      fetchVehicles({
        apiId: 'fetchVehicles'
      });
  }, []);

  useEffect(() => {
    const { period } = request;
    const queryPeriod = getQueryStringKeys(history.location.search, 'period');
    const companyId = Number(
      getQueryStringKeys(history.location.search, 'companyId')
    );

    // Removing displayLength, displayStart, sortCol, sortDir from result
    const filteredRequest = (({
      displayLength,
      displayStart,
      sortCol,
      sortDir,
      ...rest
    }) => rest)(request);

    Object.keys(chartTypes).forEach((chartType) => {
      fetchReportChart({
        apiId: `${chartType}_API`,
        data: {
          request: {
            ...filteredRequest,
            period: period || queryPeriod,
            companyId,
            chartType
          }
        }
      });
    });

    fetchReportList({
      apiId: 'fetchReportsListApi',
      data: {
        request: { ...request, period: period || queryPeriod, companyId }
      }
    });
  }, [request]);

  return (
    <>
      <RenderComponent
        {...config.scorecardReport[0]}
        parentProps={{
          ...parentProps
        }}
        commonParentProps={commonParentProps}
        component={Title}
      />
      <RenderComponent
        {...config.scorecardReport[1]}
        parentProps={{
          ...parentProps,
          changeRequest,
          request,
          pagination,
          setPagination,
          companyId: getQueryStringKeys(history.location.search, 'companyId')
        }}
        commonParentProps={commonParentProps}
        component={Content}
        pagination={pagination}
        setPagination={setPagination}
      />
    </>
  );
};

const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    paginateList: state.scoreCard.reportList,
    chartsData: state.scoreCard.chartsData,
    vehicles: state.vehicles,
    filters: state.filters
  };
};

const mapDispatch = (dispatch) => {
  return {
    fetchVehicles: (data) => dispatch.vehicles.fetchData(data),
    fetchReportList: (data) => dispatch.scoreCard.fetchReportList(data),
    fetchReportChart: (data) => dispatch.scoreCard.fetchReportChart(data),
    downloadDocument: (data) => dispatch.reports.downloadReport(data)
  };
};

export default connect(mapState, mapDispatch)(ScorecardReport);
